module.exports = __webpack_public_path__ + "img/new_report2.c2e597e6.png";